export const Experiences = [
  {
    direction: "right",
    title: "Senior Analyst, Product Management",
    link: "https://www.dell.com/en-in",
    start: "June 2024",
    end: "Present",
    organisation: "Dell Technologies",
  },
  {
    direction: "left",
    title: "Product Intern",
    link: "https://www.dell.com/en-in",
    start: "February 2024",
    end: "May 2024",
    organisation: "Dell Technologies",
  },
    {
    direction: "right",
    title: "Product Engineering Intern",
    link: "https://whitecarrot.io",
    start: "May 2023",
    end: "January 2024",
    organisation: "Whitecarrot.io",
  },
  {
    direction: "left",
    title: "Software Engineer Intern",
    link: "https://equiseedwealth.com",
    start: "May 2021",
    end: "August 2021",
    organisation: "Equiseed Wealth",
  },
  {
    direction: "right",
    title: "Research Content Writer Intern",
    link: "https://thesocians.com",
    start: "June 2020",
    end: "August 2020",
    organisation: "The Socians",
  },
  {
    direction: "left",
    title: "Software Developer Intern",
    link: "https://wondermaths.com",
    start: "December 2019",
    end: "February 2020",
    organisation: "Wonder Maths",
  },
];
